export default {
  cities: state => state.cities,
  languages: state => state.languages,
  occupations: state => state.occupations,
  skills: state => state.skills,
  worklocations: state => state.worklocations
}



// WEBPACK FOOTER //
// ./src/store/modules/resources/getters.js